import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class ShowLocationOp extends BaseOperation {
  icon = 'far fa-search'
  showInContextMenu = true
  supportsDirs = true
  supportsBundles = true
  weight = -1000

  constructor (
    private router: Router,
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
  ) {
    super()
    this.label = translate.instant('Show location')
  }

  isVisibleForDir (_dir, context) {
    return context.isSearch
  }

  isVisibleForBundle (_bundle, context) {
    return context.isSearch
  }

  async runForDir (dir) {
    this.router.navigateByUrl(`/media/browse/${this.mediaPermissions.getPermissionForFile(dir)?.root}/${dir.parent}`)
  }

  async runForBundle (bundle) {
    this.router.navigateByUrl(`/media/browse/${this.mediaPermissions.getPermissionForBundle(bundle)?.root}/${bundle.location}`)
  }
}

MediaOperationsService.register(ShowLocationOp)
